import { Select, CourseSet } from "../../types/requirement.response";
import { ReqDetailBaseProps } from "./types";
import CourseSetRows from "./CourseSetRows";

export default function GroupReqDetail({
    programInfo,
    requirement,
    coursesMap,
    isSliceLoaded,
    handleAddCourse,
    handleDeleteCourse,
    handleFavoriteCourse,
    optimisticFavorites,
    userCourses,
    hideUnavailable,
}: ReqDetailBaseProps) {
    const rootNode = requirement.rootNode as Select;
    const groups = rootNode.children.filter(
        (child): child is CourseSet => child.type === "COURSE_SET"
    );

    if (groups.length === 0) {
        return (
            <tr>
                <td colSpan={4} className="px-4 py-6 text-sm text-gray-400 italic">
                    No course groups found for this requirement.
                </td>
            </tr>
        );
    }

    return (
        <>
            {groups.map((courseSet) => (
                <CourseSetRows
                    key={courseSet.id}
                    courseSet={courseSet}
                    programInfo={programInfo}
                    coursesMap={coursesMap}
                    isSliceLoaded={isSliceLoaded}
                    requirementId={requirement.info.id}
                    handleAddCourse={handleAddCourse}
                    handleDeleteCourse={handleDeleteCourse}
                    handleFavoriteCourse={handleFavoriteCourse}
                    optimisticFavorites={optimisticFavorites}
                    userCourses={userCourses}
                    hideUnavailable={hideUnavailable}
                    showHeader
                    emptyMessage="No courses found in this group."
                />
            ))}
        </>
    );
}
